// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/dashboard.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { PortRole, portRoleFromJSON, portRoleToJSON } from "./fabric";
import { Metadata } from "./types";

export const protobufPackage = "models";

/** Panel type enum */
export enum PanelType {
  PANEL_TYPE_UNSPECIFIED = 0,
  SERVER_PORT_COUNTER = 1,
  SWITCH_PORT_COUNTER = 2,
  SERVER_ENVIRONMENTALS = 3,
  SWITCH_ENVIRONMENTALS = 4,
  UNRECOGNIZED = -1,
}

export function panelTypeFromJSON(object: any): PanelType {
  switch (object) {
    case 0:
    case "PANEL_TYPE_UNSPECIFIED":
      return PanelType.PANEL_TYPE_UNSPECIFIED;
    case 1:
    case "SERVER_PORT_COUNTER":
      return PanelType.SERVER_PORT_COUNTER;
    case 2:
    case "SWITCH_PORT_COUNTER":
      return PanelType.SWITCH_PORT_COUNTER;
    case 3:
    case "SERVER_ENVIRONMENTALS":
      return PanelType.SERVER_ENVIRONMENTALS;
    case 4:
    case "SWITCH_ENVIRONMENTALS":
      return PanelType.SWITCH_ENVIRONMENTALS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PanelType.UNRECOGNIZED;
  }
}

export function panelTypeToJSON(object: PanelType): string {
  switch (object) {
    case PanelType.PANEL_TYPE_UNSPECIFIED:
      return "PANEL_TYPE_UNSPECIFIED";
    case PanelType.SERVER_PORT_COUNTER:
      return "SERVER_PORT_COUNTER";
    case PanelType.SWITCH_PORT_COUNTER:
      return "SWITCH_PORT_COUNTER";
    case PanelType.SERVER_ENVIRONMENTALS:
      return "SERVER_ENVIRONMENTALS";
    case PanelType.SWITCH_ENVIRONMENTALS:
      return "SWITCH_ENVIRONMENTALS";
    case PanelType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Environmental temperature enum */
export enum PanelTemperature {
  PANEL_ENVIRONMENTAL_TEMPERATURE_UNSPECIFIED = 0,
  TEMPERATURE_NORMAL = 1,
  TEMPERATURE_HIGH = 2,
  TEMPERATURE_CRITICAL = 3,
  UNRECOGNIZED = -1,
}

export function panelTemperatureFromJSON(object: any): PanelTemperature {
  switch (object) {
    case 0:
    case "PANEL_ENVIRONMENTAL_TEMPERATURE_UNSPECIFIED":
      return PanelTemperature.PANEL_ENVIRONMENTAL_TEMPERATURE_UNSPECIFIED;
    case 1:
    case "TEMPERATURE_NORMAL":
      return PanelTemperature.TEMPERATURE_NORMAL;
    case 2:
    case "TEMPERATURE_HIGH":
      return PanelTemperature.TEMPERATURE_HIGH;
    case 3:
    case "TEMPERATURE_CRITICAL":
      return PanelTemperature.TEMPERATURE_CRITICAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PanelTemperature.UNRECOGNIZED;
  }
}

export function panelTemperatureToJSON(object: PanelTemperature): string {
  switch (object) {
    case PanelTemperature.PANEL_ENVIRONMENTAL_TEMPERATURE_UNSPECIFIED:
      return "PANEL_ENVIRONMENTAL_TEMPERATURE_UNSPECIFIED";
    case PanelTemperature.TEMPERATURE_NORMAL:
      return "TEMPERATURE_NORMAL";
    case PanelTemperature.TEMPERATURE_HIGH:
      return "TEMPERATURE_HIGH";
    case PanelTemperature.TEMPERATURE_CRITICAL:
      return "TEMPERATURE_CRITICAL";
    case PanelTemperature.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Device type enum for filtering */
export enum DeviceType {
  DEVICE_TYPE_UNSPECIFIED = 0,
  DEVICE_TYPE_SWITCH = 1,
  DEVICE_TYPE_SERVER = 2,
  UNRECOGNIZED = -1,
}

export function deviceTypeFromJSON(object: any): DeviceType {
  switch (object) {
    case 0:
    case "DEVICE_TYPE_UNSPECIFIED":
      return DeviceType.DEVICE_TYPE_UNSPECIFIED;
    case 1:
    case "DEVICE_TYPE_SWITCH":
      return DeviceType.DEVICE_TYPE_SWITCH;
    case 2:
    case "DEVICE_TYPE_SERVER":
      return DeviceType.DEVICE_TYPE_SERVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeviceType.UNRECOGNIZED;
  }
}

export function deviceTypeToJSON(object: DeviceType): string {
  switch (object) {
    case DeviceType.DEVICE_TYPE_UNSPECIFIED:
      return "DEVICE_TYPE_UNSPECIFIED";
    case DeviceType.DEVICE_TYPE_SWITCH:
      return "DEVICE_TYPE_SWITCH";
    case DeviceType.DEVICE_TYPE_SERVER:
      return "DEVICE_TYPE_SERVER";
    case DeviceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Chart enum */
export enum MetricType {
  METRIC_UNSPECIFIED = 0,
  /** METRIC_IN_OCTETS - basic counters */
  METRIC_IN_OCTETS = 1,
  METRIC_IN_PKTS = 2,
  METRIC_IN_DISCARDS = 3,
  METRIC_IN_ERRORS = 4,
  METRIC_OUT_OCTETS = 5,
  METRIC_OUT_PKTS = 6,
  METRIC_OUT_DISCARDS = 7,
  METRIC_OUT_ERRORS = 8,
  /** METRIC_IN_PFC0_PKTS - PFC counters */
  METRIC_IN_PFC0_PKTS = 9,
  METRIC_OUT_PFC0_PKTS = 10,
  METRIC_IN_PFC1_PKTS = 11,
  METRIC_OUT_PFC1_PKTS = 12,
  METRIC_IN_PFC2_PKTS = 13,
  METRIC_OUT_PFC2_PKTS = 14,
  METRIC_IN_PFC3_PKTS = 15,
  METRIC_OUT_PFC3_PKTS = 16,
  METRIC_IN_PFC4_PKTS = 17,
  METRIC_OUT_PFC4_PKTS = 18,
  METRIC_IN_PFC5_PKTS = 19,
  METRIC_OUT_PFC5_PKTS = 20,
  METRIC_IN_PFC6_PKTS = 21,
  METRIC_OUT_PFC6_PKTS = 22,
  METRIC_IN_PFC7_PKTS = 23,
  METRIC_OUT_PFC7_PKTS = 24,
  /** METRIC_RX_MINUTE_RATE - Rate metrics (computed) */
  METRIC_RX_MINUTE_RATE = 25,
  METRIC_TX_MINUTE_RATE = 26,
  /** METRIC_IN_BITSPS - Rate metrics (from device) */
  METRIC_IN_BITSPS = 27,
  METRIC_OUT_BITSPS = 28,
  METRIC_IN_PPS = 29,
  METRIC_OUT_PPS = 30,
  METRIC_IN_UNICAST_PPS = 31,
  METRIC_OUT_UNICAST_PPS = 32,
  METRIC_IN_PFC_PPS = 33,
  METRIC_OUT_PFC_PPS = 34,
  /** METRIC_IN_UNICAST_PKTS - Packet type counters */
  METRIC_IN_UNICAST_PKTS = 35,
  METRIC_IN_BROADCAST_PKTS = 36,
  METRIC_IN_MULTICAST_PKTS = 37,
  METRIC_OUT_UNICAST_PKTS = 38,
  METRIC_OUT_BROADCAST_PKTS = 39,
  METRIC_OUT_MULTICAST_PKTS = 40,
  UNRECOGNIZED = -1,
}

export function metricTypeFromJSON(object: any): MetricType {
  switch (object) {
    case 0:
    case "METRIC_UNSPECIFIED":
      return MetricType.METRIC_UNSPECIFIED;
    case 1:
    case "METRIC_IN_OCTETS":
      return MetricType.METRIC_IN_OCTETS;
    case 2:
    case "METRIC_IN_PKTS":
      return MetricType.METRIC_IN_PKTS;
    case 3:
    case "METRIC_IN_DISCARDS":
      return MetricType.METRIC_IN_DISCARDS;
    case 4:
    case "METRIC_IN_ERRORS":
      return MetricType.METRIC_IN_ERRORS;
    case 5:
    case "METRIC_OUT_OCTETS":
      return MetricType.METRIC_OUT_OCTETS;
    case 6:
    case "METRIC_OUT_PKTS":
      return MetricType.METRIC_OUT_PKTS;
    case 7:
    case "METRIC_OUT_DISCARDS":
      return MetricType.METRIC_OUT_DISCARDS;
    case 8:
    case "METRIC_OUT_ERRORS":
      return MetricType.METRIC_OUT_ERRORS;
    case 9:
    case "METRIC_IN_PFC0_PKTS":
      return MetricType.METRIC_IN_PFC0_PKTS;
    case 10:
    case "METRIC_OUT_PFC0_PKTS":
      return MetricType.METRIC_OUT_PFC0_PKTS;
    case 11:
    case "METRIC_IN_PFC1_PKTS":
      return MetricType.METRIC_IN_PFC1_PKTS;
    case 12:
    case "METRIC_OUT_PFC1_PKTS":
      return MetricType.METRIC_OUT_PFC1_PKTS;
    case 13:
    case "METRIC_IN_PFC2_PKTS":
      return MetricType.METRIC_IN_PFC2_PKTS;
    case 14:
    case "METRIC_OUT_PFC2_PKTS":
      return MetricType.METRIC_OUT_PFC2_PKTS;
    case 15:
    case "METRIC_IN_PFC3_PKTS":
      return MetricType.METRIC_IN_PFC3_PKTS;
    case 16:
    case "METRIC_OUT_PFC3_PKTS":
      return MetricType.METRIC_OUT_PFC3_PKTS;
    case 17:
    case "METRIC_IN_PFC4_PKTS":
      return MetricType.METRIC_IN_PFC4_PKTS;
    case 18:
    case "METRIC_OUT_PFC4_PKTS":
      return MetricType.METRIC_OUT_PFC4_PKTS;
    case 19:
    case "METRIC_IN_PFC5_PKTS":
      return MetricType.METRIC_IN_PFC5_PKTS;
    case 20:
    case "METRIC_OUT_PFC5_PKTS":
      return MetricType.METRIC_OUT_PFC5_PKTS;
    case 21:
    case "METRIC_IN_PFC6_PKTS":
      return MetricType.METRIC_IN_PFC6_PKTS;
    case 22:
    case "METRIC_OUT_PFC6_PKTS":
      return MetricType.METRIC_OUT_PFC6_PKTS;
    case 23:
    case "METRIC_IN_PFC7_PKTS":
      return MetricType.METRIC_IN_PFC7_PKTS;
    case 24:
    case "METRIC_OUT_PFC7_PKTS":
      return MetricType.METRIC_OUT_PFC7_PKTS;
    case 25:
    case "METRIC_RX_MINUTE_RATE":
      return MetricType.METRIC_RX_MINUTE_RATE;
    case 26:
    case "METRIC_TX_MINUTE_RATE":
      return MetricType.METRIC_TX_MINUTE_RATE;
    case 27:
    case "METRIC_IN_BITSPS":
      return MetricType.METRIC_IN_BITSPS;
    case 28:
    case "METRIC_OUT_BITSPS":
      return MetricType.METRIC_OUT_BITSPS;
    case 29:
    case "METRIC_IN_PPS":
      return MetricType.METRIC_IN_PPS;
    case 30:
    case "METRIC_OUT_PPS":
      return MetricType.METRIC_OUT_PPS;
    case 31:
    case "METRIC_IN_UNICAST_PPS":
      return MetricType.METRIC_IN_UNICAST_PPS;
    case 32:
    case "METRIC_OUT_UNICAST_PPS":
      return MetricType.METRIC_OUT_UNICAST_PPS;
    case 33:
    case "METRIC_IN_PFC_PPS":
      return MetricType.METRIC_IN_PFC_PPS;
    case 34:
    case "METRIC_OUT_PFC_PPS":
      return MetricType.METRIC_OUT_PFC_PPS;
    case 35:
    case "METRIC_IN_UNICAST_PKTS":
      return MetricType.METRIC_IN_UNICAST_PKTS;
    case 36:
    case "METRIC_IN_BROADCAST_PKTS":
      return MetricType.METRIC_IN_BROADCAST_PKTS;
    case 37:
    case "METRIC_IN_MULTICAST_PKTS":
      return MetricType.METRIC_IN_MULTICAST_PKTS;
    case 38:
    case "METRIC_OUT_UNICAST_PKTS":
      return MetricType.METRIC_OUT_UNICAST_PKTS;
    case 39:
    case "METRIC_OUT_BROADCAST_PKTS":
      return MetricType.METRIC_OUT_BROADCAST_PKTS;
    case 40:
    case "METRIC_OUT_MULTICAST_PKTS":
      return MetricType.METRIC_OUT_MULTICAST_PKTS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetricType.UNRECOGNIZED;
  }
}

export function metricTypeToJSON(object: MetricType): string {
  switch (object) {
    case MetricType.METRIC_UNSPECIFIED:
      return "METRIC_UNSPECIFIED";
    case MetricType.METRIC_IN_OCTETS:
      return "METRIC_IN_OCTETS";
    case MetricType.METRIC_IN_PKTS:
      return "METRIC_IN_PKTS";
    case MetricType.METRIC_IN_DISCARDS:
      return "METRIC_IN_DISCARDS";
    case MetricType.METRIC_IN_ERRORS:
      return "METRIC_IN_ERRORS";
    case MetricType.METRIC_OUT_OCTETS:
      return "METRIC_OUT_OCTETS";
    case MetricType.METRIC_OUT_PKTS:
      return "METRIC_OUT_PKTS";
    case MetricType.METRIC_OUT_DISCARDS:
      return "METRIC_OUT_DISCARDS";
    case MetricType.METRIC_OUT_ERRORS:
      return "METRIC_OUT_ERRORS";
    case MetricType.METRIC_IN_PFC0_PKTS:
      return "METRIC_IN_PFC0_PKTS";
    case MetricType.METRIC_OUT_PFC0_PKTS:
      return "METRIC_OUT_PFC0_PKTS";
    case MetricType.METRIC_IN_PFC1_PKTS:
      return "METRIC_IN_PFC1_PKTS";
    case MetricType.METRIC_OUT_PFC1_PKTS:
      return "METRIC_OUT_PFC1_PKTS";
    case MetricType.METRIC_IN_PFC2_PKTS:
      return "METRIC_IN_PFC2_PKTS";
    case MetricType.METRIC_OUT_PFC2_PKTS:
      return "METRIC_OUT_PFC2_PKTS";
    case MetricType.METRIC_IN_PFC3_PKTS:
      return "METRIC_IN_PFC3_PKTS";
    case MetricType.METRIC_OUT_PFC3_PKTS:
      return "METRIC_OUT_PFC3_PKTS";
    case MetricType.METRIC_IN_PFC4_PKTS:
      return "METRIC_IN_PFC4_PKTS";
    case MetricType.METRIC_OUT_PFC4_PKTS:
      return "METRIC_OUT_PFC4_PKTS";
    case MetricType.METRIC_IN_PFC5_PKTS:
      return "METRIC_IN_PFC5_PKTS";
    case MetricType.METRIC_OUT_PFC5_PKTS:
      return "METRIC_OUT_PFC5_PKTS";
    case MetricType.METRIC_IN_PFC6_PKTS:
      return "METRIC_IN_PFC6_PKTS";
    case MetricType.METRIC_OUT_PFC6_PKTS:
      return "METRIC_OUT_PFC6_PKTS";
    case MetricType.METRIC_IN_PFC7_PKTS:
      return "METRIC_IN_PFC7_PKTS";
    case MetricType.METRIC_OUT_PFC7_PKTS:
      return "METRIC_OUT_PFC7_PKTS";
    case MetricType.METRIC_RX_MINUTE_RATE:
      return "METRIC_RX_MINUTE_RATE";
    case MetricType.METRIC_TX_MINUTE_RATE:
      return "METRIC_TX_MINUTE_RATE";
    case MetricType.METRIC_IN_BITSPS:
      return "METRIC_IN_BITSPS";
    case MetricType.METRIC_OUT_BITSPS:
      return "METRIC_OUT_BITSPS";
    case MetricType.METRIC_IN_PPS:
      return "METRIC_IN_PPS";
    case MetricType.METRIC_OUT_PPS:
      return "METRIC_OUT_PPS";
    case MetricType.METRIC_IN_UNICAST_PPS:
      return "METRIC_IN_UNICAST_PPS";
    case MetricType.METRIC_OUT_UNICAST_PPS:
      return "METRIC_OUT_UNICAST_PPS";
    case MetricType.METRIC_IN_PFC_PPS:
      return "METRIC_IN_PFC_PPS";
    case MetricType.METRIC_OUT_PFC_PPS:
      return "METRIC_OUT_PFC_PPS";
    case MetricType.METRIC_IN_UNICAST_PKTS:
      return "METRIC_IN_UNICAST_PKTS";
    case MetricType.METRIC_IN_BROADCAST_PKTS:
      return "METRIC_IN_BROADCAST_PKTS";
    case MetricType.METRIC_IN_MULTICAST_PKTS:
      return "METRIC_IN_MULTICAST_PKTS";
    case MetricType.METRIC_OUT_UNICAST_PKTS:
      return "METRIC_OUT_UNICAST_PKTS";
    case MetricType.METRIC_OUT_BROADCAST_PKTS:
      return "METRIC_OUT_BROADCAST_PKTS";
    case MetricType.METRIC_OUT_MULTICAST_PKTS:
      return "METRIC_OUT_MULTICAST_PKTS";
    case MetricType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Dashboard represents a saved collection of panels for monitoring telemetry. */
export interface Dashboard {
  /** The unique identifier of the dashboard. */
  id: string;
  /** The fabric ID this dashboard belongs to. */
  fabricId: string;
  /** The folder ID this dashboard belongs to (optional, defaults to default folder). */
  folderId: string;
  /** The user-defined name of the dashboard. */
  name: string;
  /** The description is a user-defined field to store notes about the dashboard. */
  description: string;
  /** A map of attributes related to the lifecycle of the dashboard. */
  metadata: Metadata | undefined;
}

/** DashboardFolder is a container for organizing dashboards within a fabric. */
export interface DashboardFolder {
  /** The unique identifier of the folder. */
  id: string;
  /** The fabric ID this folder belongs to. */
  fabricId: string;
  /** The user-defined name of the folder. */
  name: string;
  /** A map of attributes related to the lifecycle of the folder. */
  metadata: Metadata | undefined;
}

export interface DashboardPanelQueryPortCounter {
  /**
   * Port counter panel fields (type: serverPortCounter, switchPortCounter)
   * Port range (e.g., "1,3" or "1-10", empty = all)
   */
  portRange: string;
  /** Specific interface name (e.g., "Ethernet1/1") */
  interfaceName: string;
  /** Port role filter using NetworkPort PortRole values. */
  portRoles: PortRole[];
  /** VNI/Logical network name (e.g., "vni-10") */
  logicalNetwork: string;
  /** VLAN tag (e.g., "1234") */
  vlanTag: string;
  /** Port labels (e.g., "Port label2") */
  portLabels: string[];
}

export interface DashboardPanelQueryEnvironmentals {
  /**
   * Environmental panel fields (type: serverEnvironmentals, switchEnvironmentals)
   * Temperature filter (e.g., "high", "normal", "critical")
   */
  temperature: PanelTemperature;
}

export interface DashboardPanelQuery {
  /**
   * Common fields (used by all panel types)
   * Device group names (e.g., "GPU Servers")
   */
  groupNames: string[];
  /** Specific device name (empty = all in group) */
  deviceName: string;
  /** Device labels (e.g., "Device label2") */
  deviceLabels: string[];
  /** Device type filter (Switch or Server) */
  deviceType: DeviceType;
  /** Port Counter Query */
  portCounter:
    | DashboardPanelQueryPortCounter
    | undefined;
  /** Environmental Query */
  environmentals: DashboardPanelQueryEnvironmentals | undefined;
}

export interface DashboardPanelConfig {
  /** The panel query */
  query:
    | DashboardPanelQuery
    | undefined;
  /** The panel metric names */
  charts: MetricType[];
}

/** Dashboard Panel configuration */
export interface Panel {
  /** The unique identifier of the panel. */
  id: string;
  /** The fabric ID this panel belongs to. */
  fabricId: string;
  /** The folder ID this panel belongs to. */
  folderId: string;
  /** The dashboard ID this panel belongs to. */
  dashboardId: string;
  /** The user-defined name of the panel. */
  name: string;
  /** The description is a user-defined field to store notes about the panel. */
  description: string;
  /** The position of the panel in the dashboard. */
  position: number;
  /** The panel type */
  type: PanelType;
  /** The panel config */
  config:
    | DashboardPanelConfig
    | undefined;
  /** A map of attributes related to the lifecycle of the panel. */
  metadata: Metadata | undefined;
}

function createBaseDashboard(): Dashboard {
  return { id: "", fabricId: "", folderId: "", name: "", description: "", metadata: undefined };
}

export const Dashboard: MessageFns<Dashboard> = {
  encode(message: Dashboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(26).string(message.folderId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Dashboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboard();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Dashboard {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: Dashboard): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Dashboard>, I>>(base?: I): Dashboard {
    return Dashboard.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Dashboard>, I>>(object: I): Dashboard {
    const message = createBaseDashboard();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseDashboardFolder(): DashboardFolder {
  return { id: "", fabricId: "", name: "", metadata: undefined };
}

export const DashboardFolder: MessageFns<DashboardFolder> = {
  encode(message: DashboardFolder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardFolder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardFolder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardFolder {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: DashboardFolder): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardFolder>, I>>(base?: I): DashboardFolder {
    return DashboardFolder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardFolder>, I>>(object: I): DashboardFolder {
    const message = createBaseDashboardFolder();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseDashboardPanelQueryPortCounter(): DashboardPanelQueryPortCounter {
  return { portRange: "", interfaceName: "", portRoles: [], logicalNetwork: "", vlanTag: "", portLabels: [] };
}

export const DashboardPanelQueryPortCounter: MessageFns<DashboardPanelQueryPortCounter> = {
  encode(message: DashboardPanelQueryPortCounter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portRange !== "") {
      writer.uint32(10).string(message.portRange);
    }
    if (message.interfaceName !== "") {
      writer.uint32(18).string(message.interfaceName);
    }
    writer.uint32(26).fork();
    for (const v of message.portRoles) {
      writer.int32(v);
    }
    writer.join();
    if (message.logicalNetwork !== "") {
      writer.uint32(34).string(message.logicalNetwork);
    }
    if (message.vlanTag !== "") {
      writer.uint32(42).string(message.vlanTag);
    }
    for (const v of message.portLabels) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanelQueryPortCounter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanelQueryPortCounter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portRange = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interfaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.portRoles.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.portRoles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.logicalNetwork = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vlanTag = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.portLabels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanelQueryPortCounter {
    return {
      portRange: isSet(object.portRange) ? globalThis.String(object.portRange) : "",
      interfaceName: isSet(object.interfaceName) ? globalThis.String(object.interfaceName) : "",
      portRoles: globalThis.Array.isArray(object?.portRoles)
        ? object.portRoles.map((e: any) => portRoleFromJSON(e))
        : [],
      logicalNetwork: isSet(object.logicalNetwork) ? globalThis.String(object.logicalNetwork) : "",
      vlanTag: isSet(object.vlanTag) ? globalThis.String(object.vlanTag) : "",
      portLabels: globalThis.Array.isArray(object?.portLabels)
        ? object.portLabels.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DashboardPanelQueryPortCounter): unknown {
    const obj: any = {};
    if (message.portRange !== "") {
      obj.portRange = message.portRange;
    }
    if (message.interfaceName !== "") {
      obj.interfaceName = message.interfaceName;
    }
    if (message.portRoles?.length) {
      obj.portRoles = message.portRoles.map((e) => portRoleToJSON(e));
    }
    if (message.logicalNetwork !== "") {
      obj.logicalNetwork = message.logicalNetwork;
    }
    if (message.vlanTag !== "") {
      obj.vlanTag = message.vlanTag;
    }
    if (message.portLabels?.length) {
      obj.portLabels = message.portLabels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanelQueryPortCounter>, I>>(base?: I): DashboardPanelQueryPortCounter {
    return DashboardPanelQueryPortCounter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanelQueryPortCounter>, I>>(
    object: I,
  ): DashboardPanelQueryPortCounter {
    const message = createBaseDashboardPanelQueryPortCounter();
    message.portRange = object.portRange ?? "";
    message.interfaceName = object.interfaceName ?? "";
    message.portRoles = object.portRoles?.map((e) => e) || [];
    message.logicalNetwork = object.logicalNetwork ?? "";
    message.vlanTag = object.vlanTag ?? "";
    message.portLabels = object.portLabels?.map((e) => e) || [];
    return message;
  },
};

function createBaseDashboardPanelQueryEnvironmentals(): DashboardPanelQueryEnvironmentals {
  return { temperature: 0 };
}

export const DashboardPanelQueryEnvironmentals: MessageFns<DashboardPanelQueryEnvironmentals> = {
  encode(message: DashboardPanelQueryEnvironmentals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.temperature !== 0) {
      writer.uint32(8).int32(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanelQueryEnvironmentals {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanelQueryEnvironmentals();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.temperature = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanelQueryEnvironmentals {
    return { temperature: isSet(object.temperature) ? panelTemperatureFromJSON(object.temperature) : 0 };
  },

  toJSON(message: DashboardPanelQueryEnvironmentals): unknown {
    const obj: any = {};
    if (message.temperature !== 0) {
      obj.temperature = panelTemperatureToJSON(message.temperature);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanelQueryEnvironmentals>, I>>(
    base?: I,
  ): DashboardPanelQueryEnvironmentals {
    return DashboardPanelQueryEnvironmentals.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanelQueryEnvironmentals>, I>>(
    object: I,
  ): DashboardPanelQueryEnvironmentals {
    const message = createBaseDashboardPanelQueryEnvironmentals();
    message.temperature = object.temperature ?? 0;
    return message;
  },
};

function createBaseDashboardPanelQuery(): DashboardPanelQuery {
  return {
    groupNames: [],
    deviceName: "",
    deviceLabels: [],
    deviceType: 0,
    portCounter: undefined,
    environmentals: undefined,
  };
}

export const DashboardPanelQuery: MessageFns<DashboardPanelQuery> = {
  encode(message: DashboardPanelQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.groupNames) {
      writer.uint32(10).string(v!);
    }
    if (message.deviceName !== "") {
      writer.uint32(18).string(message.deviceName);
    }
    for (const v of message.deviceLabels) {
      writer.uint32(26).string(v!);
    }
    if (message.deviceType !== 0) {
      writer.uint32(32).int32(message.deviceType);
    }
    if (message.portCounter !== undefined) {
      DashboardPanelQueryPortCounter.encode(message.portCounter, writer.uint32(82).fork()).join();
    }
    if (message.environmentals !== undefined) {
      DashboardPanelQueryEnvironmentals.encode(message.environmentals, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanelQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanelQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groupNames.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceLabels.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.portCounter = DashboardPanelQueryPortCounter.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.environmentals = DashboardPanelQueryEnvironmentals.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanelQuery {
    return {
      groupNames: globalThis.Array.isArray(object?.groupNames)
        ? object.groupNames.map((e: any) => globalThis.String(e))
        : [],
      deviceName: isSet(object.deviceName) ? globalThis.String(object.deviceName) : "",
      deviceLabels: globalThis.Array.isArray(object?.deviceLabels)
        ? object.deviceLabels.map((e: any) => globalThis.String(e))
        : [],
      deviceType: isSet(object.deviceType) ? deviceTypeFromJSON(object.deviceType) : 0,
      portCounter: isSet(object.portCounter) ? DashboardPanelQueryPortCounter.fromJSON(object.portCounter) : undefined,
      environmentals: isSet(object.environmentals)
        ? DashboardPanelQueryEnvironmentals.fromJSON(object.environmentals)
        : undefined,
    };
  },

  toJSON(message: DashboardPanelQuery): unknown {
    const obj: any = {};
    if (message.groupNames?.length) {
      obj.groupNames = message.groupNames;
    }
    if (message.deviceName !== "") {
      obj.deviceName = message.deviceName;
    }
    if (message.deviceLabels?.length) {
      obj.deviceLabels = message.deviceLabels;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = deviceTypeToJSON(message.deviceType);
    }
    if (message.portCounter !== undefined) {
      obj.portCounter = DashboardPanelQueryPortCounter.toJSON(message.portCounter);
    }
    if (message.environmentals !== undefined) {
      obj.environmentals = DashboardPanelQueryEnvironmentals.toJSON(message.environmentals);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanelQuery>, I>>(base?: I): DashboardPanelQuery {
    return DashboardPanelQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanelQuery>, I>>(object: I): DashboardPanelQuery {
    const message = createBaseDashboardPanelQuery();
    message.groupNames = object.groupNames?.map((e) => e) || [];
    message.deviceName = object.deviceName ?? "";
    message.deviceLabels = object.deviceLabels?.map((e) => e) || [];
    message.deviceType = object.deviceType ?? 0;
    message.portCounter = (object.portCounter !== undefined && object.portCounter !== null)
      ? DashboardPanelQueryPortCounter.fromPartial(object.portCounter)
      : undefined;
    message.environmentals = (object.environmentals !== undefined && object.environmentals !== null)
      ? DashboardPanelQueryEnvironmentals.fromPartial(object.environmentals)
      : undefined;
    return message;
  },
};

function createBaseDashboardPanelConfig(): DashboardPanelConfig {
  return { query: undefined, charts: [] };
}

export const DashboardPanelConfig: MessageFns<DashboardPanelConfig> = {
  encode(message: DashboardPanelConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query !== undefined) {
      DashboardPanelQuery.encode(message.query, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.charts) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DashboardPanelConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDashboardPanelConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = DashboardPanelQuery.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.charts.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.charts.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DashboardPanelConfig {
    return {
      query: isSet(object.query) ? DashboardPanelQuery.fromJSON(object.query) : undefined,
      charts: globalThis.Array.isArray(object?.charts) ? object.charts.map((e: any) => metricTypeFromJSON(e)) : [],
    };
  },

  toJSON(message: DashboardPanelConfig): unknown {
    const obj: any = {};
    if (message.query !== undefined) {
      obj.query = DashboardPanelQuery.toJSON(message.query);
    }
    if (message.charts?.length) {
      obj.charts = message.charts.map((e) => metricTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DashboardPanelConfig>, I>>(base?: I): DashboardPanelConfig {
    return DashboardPanelConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DashboardPanelConfig>, I>>(object: I): DashboardPanelConfig {
    const message = createBaseDashboardPanelConfig();
    message.query = (object.query !== undefined && object.query !== null)
      ? DashboardPanelQuery.fromPartial(object.query)
      : undefined;
    message.charts = object.charts?.map((e) => e) || [];
    return message;
  },
};

function createBasePanel(): Panel {
  return {
    id: "",
    fabricId: "",
    folderId: "",
    dashboardId: "",
    name: "",
    description: "",
    position: 0,
    type: 0,
    config: undefined,
    metadata: undefined,
  };
}

export const Panel: MessageFns<Panel> = {
  encode(message: Panel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.folderId !== "") {
      writer.uint32(26).string(message.folderId);
    }
    if (message.dashboardId !== "") {
      writer.uint32(34).string(message.dashboardId);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.position !== 0) {
      writer.uint32(56).uint32(message.position);
    }
    if (message.type !== 0) {
      writer.uint32(64).int32(message.type);
    }
    if (message.config !== undefined) {
      DashboardPanelConfig.encode(message.config, writer.uint32(74).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Panel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePanel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dashboardId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.config = DashboardPanelConfig.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Panel {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      folderId: isSet(object.folderId) ? globalThis.String(object.folderId) : "",
      dashboardId: isSet(object.dashboardId) ? globalThis.String(object.dashboardId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      type: isSet(object.type) ? panelTypeFromJSON(object.type) : 0,
      config: isSet(object.config) ? DashboardPanelConfig.fromJSON(object.config) : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: Panel): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.dashboardId !== "") {
      obj.dashboardId = message.dashboardId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.type !== 0) {
      obj.type = panelTypeToJSON(message.type);
    }
    if (message.config !== undefined) {
      obj.config = DashboardPanelConfig.toJSON(message.config);
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Panel>, I>>(base?: I): Panel {
    return Panel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Panel>, I>>(object: I): Panel {
    const message = createBasePanel();
    message.id = object.id ?? "";
    message.fabricId = object.fabricId ?? "";
    message.folderId = object.folderId ?? "";
    message.dashboardId = object.dashboardId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.position = object.position ?? 0;
    message.type = object.type ?? 0;
    message.config = (object.config !== undefined && object.config !== null)
      ? DashboardPanelConfig.fromPartial(object.config)
      : undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
